import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { EquipmentsApi } from '@core/api/equipments/equipments.api';
import { searchManyInputStyles } from '@core/components/fc-input/base/fc-search-many-input/fc-search-many-input.component';
import { clearEmptyProperties, endOfDay, mapCheckbox, mapIds, startOfDay } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { cloneDeep } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { AuthenticationService } from '../../../core/authentication/authentication.service';
import { WARRANTY_STATUS } from '../../../core/consts';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';


@Component({
  selector: 'filter-equipments',
  templateUrl: './filter-equipments.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FilterEquipmentsComponent implements OnInit {
  public types: any[] = [];
  public locations: any[] = [];
  public filtersForm: FormGroup;
  public filterChanged = new BehaviorSubject<any>({ archived: false });
  public locationsIds: string[] = [];
  public desiredStyle: searchManyInputStyles = searchManyInputStyles.Outlined;

  public WARRANTY_STATUS = WARRANTY_STATUS;

  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly equipmentsApi: EquipmentsApi,
    private readonly formBuilder: FormBuilder,
    private readonly authenticationService: AuthenticationService,
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  ngOnInit(): void {

    this.equipmentsApi.getFiltersData().subscribe((result) => {
      this.types = cloneDeep(result['equipmentsTypes']['items']);
      this.locations = cloneDeep(result['locations']['items']);
    });

    this.filtersForm = this.formBuilder.group({
      name: null,
      typeId: null,
      number: null,
      segmentId: null,
      locations: null,
      archived: false,
      warrantyStartDateLte: null,
      warrantyEndDateGte: null,
      warrantyStatusIn: new FormArray(WARRANTY_STATUS.map(() => new FormControl(false))),
    });

    this.filtersForm.valueChanges.pipe(
      debounceTime(500),
      tap(() => {
        const filters = clearEmptyProperties({
          archived: this.filtersForm.value.archived,
          name_contains: this.filtersForm.value.name,
          number_contains: this.filtersForm.value.number,
          segmentId_in: this.filtersForm.value.segmentId,
          locationId_in: mapIds(this.filtersForm.value.locations),
          equipmentTypeId_in: this.filtersForm.value.typeId,
          warrantyStartDateLte: startOfDay(this.filtersForm.value.warrantyStartDateLte),
          warrantyEndDateGte: endOfDay(this.filtersForm.value.warrantyEndDateGte),
          warrantyStatusIn: mapCheckbox(this.filtersForm.value.warrantyStatusIn, this.WARRANTY_STATUS, 'name'),
        });
        this.filterChanged.next(filters);
      })
    ).subscribe();
  }

  clearFilters(): void {
    this.filtersForm.patchValue({
      name: null,
      typeId: null,
      number: null,
      archived: false,
      locations: null,
      segmentId: null,
      warrantyStartDateLte: null,
      warrantyEndDateGte: null,
      warrantyStatusIn: WARRANTY_STATUS.map(() => false),
    });
  }
}
